export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9586.fa6a6a37.jpg";